﻿import React, { useState, useEffect } from 'react';

import { ReactGrid, CellChange, TextCell, Column, Row, CellStyle, Range } from "@silevis/reactgrid";
import "@silevis/reactgrid/styles.css";


import DataGrid, {
    Column as DataGridColumn,
    Selection,
    Button as ColumnButton   
} from 'devextreme-react/data-grid';

import { TextBox, TextArea } from 'devextreme-react';
import { Button } from 'devextreme-react/button';


interface SampleRow {
    id: string;
    sampleName: string;
    chemical?: string;
    measurement?: string;
    asset?: string;
    noDilution: boolean;
}

const getSamples = (): SampleRow[] => [
    { id: "abc1", sampleName: "E1", chemical: "Methyl Isobutyrate", measurement: "10.3 mg", asset: "01234", noDilution: false },
    { id: "xr41", sampleName: "E2", chemical: "Oxazepam", measurement: "10.87 mg", asset: "01234", noDilution: true },
    { id: "abc1", sampleName: "M1", chemical: "Tigecycline", measurement: "1.23 g", asset: "01234", noDilution: false },
    { id: "wq3", sampleName: "M2", chemical: "Zolmitriptan", measurement: "11.4 mg", asset: "01234", noDilution: false },
    { id: "xxee", sampleName: "L1", chemical: "Sodium Hydroxide", measurement: "10.83 mg", asset: "01994", noDilution: true },
    { id: "alkj", sampleName: "L2", chemical: "Ammonium oxalate monohydrate", measurement: "1.23 g", asset: "08864", noDilution: false }
];

const getColumns = (): Column[] => [
    { columnId: "sampleName", width: 125 },
    { columnId: "chemical", width: 250 },
    { columnId: "chemicalLookup", width: 16 },
    { columnId: "measurement", width: 150 },
    { columnId: "asset", width: 150 },
    { columnId: "noDilution", width: 150 }
];

const headerRow: Row = {
    rowId: "header",
    cells: [
        { type: "header", text: "Sample Name", className:"reactgrid-header-cell" },
        { type: "header", text: "Chemical", className: "reactgrid-header-cell" },
        { type: "header", text: "" },
        { type: "header", text: "Measurement", className: "reactgrid-header-cell" },
        { type: "header", text: "Asset", className: "reactgrid-header-cell" },
        { type: "header", text: "No Dilution", className: "reactgrid-header-cell" }
    ]
};

const chemicalCellStyle = (): CellStyle => {
    let cellStyle: CellStyle = {
        background: "#efefef",
        color: "blue"
    };

    return cellStyle;
}

const getRows = (sr: SampleRow[]): Row[] => [
    headerRow,
    ...sr.map<Row>((sample, idx) => ({
        rowId: idx,
        cells: [
            { type: "text", text: sample.sampleName, className: "reactgrid-cell" },
            { type: "text", text: sample.chemical, className: "reactgrid-cell" },
            { type: "text", text: " ...", nonEditable: true, style: chemicalCellStyle(), className: 'reactgrid-button' },
            { type: "text", text: sample.measurement, className: "reactgrid-cell" },
            { type: "text", text: sample.asset, className: "reactgrid-cell" },
            { type: "checkbox", nonEditable: false, checked: sample.noDilution, checkedText: "1", uncheckedText: "" }
        ]
    }))
];

export default function ReactGridDemo() {
    const [samples, setSamples] =
        useState<SampleRow[]>(getSamples());

    const [rows, setRows] =
        useState<Row[]>(getRows(samples));

    useEffect(() => {
        updateRows();
    }, [samples]);

    //const rows = getRows(samples);

    const columns = getColumns();

    return (
        <div>
            <div className="pw-margin-top-1">
                <Button className="title-bar-button"
                    text="Add Row" icon="plus" type="success"
                    hint="add row"
                    onClick={onAddRowClick} />
            </div>

            <div className="pw-margin-top-1">
                <ReactGrid
                    enableFillHandle={true}
                    enableRangeSelection={true}
                    rows={rows} columns={columns}
                    onSelectionChanging={onSelectionChanging}
                    onCellsChanged={handleChanges} />
            </div>

            <div className="pw-margin-top-1">
                <DataGrid
                    height="20rem"
                    width="100%"
                    dataSource={samples ? samples : []}
                    allowColumnResizing={true}
                    columnResizingMode={'widget'}
                    showBorders={true} >

                    <Selection mode={'single'} />

                    <DataGridColumn dataField='sampleName' width='10rem' />
                    <DataGridColumn dataField='chemical' width='10rem' />
                    <DataGridColumn dataField='measurement' dataType="string" width='10rem' />
                    <DataGridColumn dataField='asset' dataType="string" width='12rem' />
                    <DataGridColumn dataField='noDilution' caption="No Dilution" dataType="boolean" width='7rem' />
                    <DataGridColumn />

                </DataGrid>
            </div>

        </div>
    );

    function onAddRowClick() {
        let editedSamples = [...samples];
        let newSample = { id: "rrwq", sampleName: "E4", chemical: "", measurement: "", asset: "", noDilution: false };
        editedSamples.push(newSample);

        setSamples(editedSamples);
    }

    function updateRows() {
        setRows(getRows(samples));
    }

    function onSelectionChanged(e: any) {
        console.log("onSelectionChanged");
        console.log(e);

    }

    function onSelectionChanging(selectedRanges: Range[]) : boolean {
        console.log("onSelectionChanging");
        console.log(selectedRanges);

        return true;
    }

    function handleChanges(changes: CellChange<TextCell>[]) {
        setSamples((prevSamples) => applyChangesToSamples(changes, prevSamples));
    };

    function applyChangesToSamples(changes: CellChange<TextCell>[],prevSamples: SampleRow[]): SampleRow[] {
        console.log("changes:");
        console.log(changes);

        changes.forEach((change) => {
            const sampleIndex = change.rowId;
            const fieldName = change.columnId;

            if (change.columnId !== "noDilution")
                prevSamples[sampleIndex][fieldName] = change.newCell.text;
            else
                prevSamples[sampleIndex][fieldName] = change.newCell.text === "1" ? true : false;


        });

        return [...prevSamples];
    };


   
}

